import type { OrderResponse } from "@/types/external/order-response"

type TotalSource = Pick<OrderResponse, "payments"> & { total?: Partial<OrderResponse["total"]> | null }

/** What the order costs, from `total.orderAmount`; `payments.pending` is only the part still owed at handover and is 0 when prepaid. */
export function orderTotalValue(order: TotalSource): number {
  const amount = order.total?.orderAmount?.value
  return typeof amount === "number" && Number.isFinite(amount) ? amount : order.payments.pending
}

/** The note the customer pays the cash line with, or null when no change is needed. */
export function cashChangeFor(order: Pick<OrderResponse, "payments">): number | null {
  const cash = order.payments.methods.find((m) => m.method === "CASH")
  const changeFor = cash?.changeFor ?? 0
  return changeFor > 0 ? changeFor : null
}
